import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  skipForward,
  skipBack
} from '../store/actions/playerAction'

import Waveform from './waveform/Waveform'
import WaveformScrubber from './waveform/WaveformScrubber'
import WaveformDisplay from './waveform/WaveformDisplay'
import Container from '../ui/Container'
import Icon from '../ui/Icon'
import Badge from '../ui/Badge'

import { secondsToTime } from 'helpers/TimeHelper'
import { debounce } from 'helpers/Debounce'

//import QueueOverlay from '../modules/queue/QueueOverlay'

class WaveformWrapper extends Component{

  constructor(props){
    super(props)
    this.state = {
      scrubberPos:0
    }
  }

  componentDidUpdate(prevProps){
    if(prevProps.currTrackPos !== this.props.currTrackPos){
      this.timeUpdate()
    }
  }

  timeUpdate(){
    const {
      currTrackPos,
      currTrackLength
    } = this.props
    const position = (currTrackPos/currTrackLength) * 100
    this.setState({
      scrubberPos:position,
      position:secondsToTime(Math.round(currTrackPos)),
      total:secondsToTime(Math.round(currTrackLength))
    })
  }

  setScrubberSelectPos(pos){
    if(this.state.audio){
      this.setState({
        scrubberSelectPos:pos
      })
    }
  }

  getScrubberPos(){
    return 
  }

  selectScrubberPos(clientWidth){
    if(this.state.audio){
      const {
        audio,
        scrubberSelectPos
      } = this.state
      const time = (scrubberSelectPos/100) * audio.duration
      audio.currentTime = time
    }
  }

  playPause(){
    const {
      dispatch,
      library,
      location,
      playlist,
      queue
    } = this.props

    const {
      audio,
      isPlaying
    } = this.state

    const isLibraryView = location.pathname === '/library'
    const isPlaylistView = location.pathname.match(/playlist|playlists/g) && !location.search.match(/library/)
    const isPlaylistLibraryView = location.pathname.match(/playlist|playlists/g) && location.search.match(/library/)

    // if audio is loaded, play or pause as appropriate
    // if not and we are on the library page, play the first track in the library
    // otherwise, if there are tracks in the queue, play the first track in the queue
    if (audio) {
      this.setState({ isPlaying: !isPlaying},() => {
        if(!isPlaying) {
          this.playPromise = audio.play()
        } else if (this.playPromise && (this  .playPromise !== undefined)) {
          this.playPromise.then(() => {
            audio.pause()
          }).catch(error => {
            console.log(error)
          });
        }
      })
      //dispatch(playPauseTrack(!isPlaying))
    } else if (!isLibraryView && !isPlaylistView && !isPlaylistLibraryView && queue.length > 0) {
      this.getTrack(queue[0], 'queue')
    } else if (isLibraryView && library.length > 0) {
      this.getTrack(library[0], 'library')
    } else if (isPlaylistLibraryView && library.length > 0) {
      this.getTrack(library[0], 'playlist-library')
    } else if (isPlaylistView && playlist.length > 0) {
      this.getTrack(playlist[0], 'playlist')
    }

  }

  skipBack() {
    this.props.dispatch(skipBack())
  }

  skipForward() {
    this.props.dispatch(skipForward())
  }

  getDetails(){
    if(this.props.track){
      const {title,artist,album} = this.props.track
      return `${title} - ${artist} - ${album}`
    } else {
      return null
    }
  }

  handleKeyDown(event) {
    if (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
      switch (event.keyCode) {
        case 32: {
          event.preventDefault()
          this.playPause()
          break
        }
        case 37: {
          this.playPrevious()
          break
        }
        case 39: {
          this.playNext()
          break
        }
      }
    }
  }

  render(){
    const {
      trackArrBuff,
      currTrackLength,
      currTrackPos
    } = this.props

    const {
      scrubberPos,
      position,
      total
    } = this.state

    return (
      <div className="waveform-container">
        <div className="controls">
          <Icon
            name="play-back"
            action={()=>this.skipBack()}
          />
          <Icon
            name={`${this.props.track ? 'pause' : 'play'}`}
            action={()=>this.playPause()}
          />
          <Icon
            name="play-forward"
            action={()=>this.skipForward()}
          />
        </div>
        <div className="waveform-wrapper">
          <Waveform
            src={trackArrBuff}
            setScrubberSelectPos={(pos)=>this.setScrubberSelectPos(pos)}
            selectScrubberPos={(clientWidth)=>this.selectScrubberPos(clientWidth)}
          />
          <WaveformScrubber
            scrubberPos={scrubberPos}
            //scrubberSelectPos={scrubberSelectPos}
          />
          <WaveformDisplay
            position={position}
            total={total}
            details={this.getDetails()}
          />
        </div>
      </div>
    )
  }
}

function mapStateToProps(store){
  return {
    track:store.player.currTrack,
    trackArrBuff:store.player.trackArrBuff,
    currTrackPos:store.player.currTrackPos,
    currTrackLength:store.player.currTrackLength
  }
}

export default withRouter(connect(mapStateToProps)(WaveformWrapper))




// WEBPACK FOOTER //
// ./src/components/WaveformWrapper.js